import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MultipleAuthDetailComponent } from '../multiple-auth-detail/multiple-auth-detail.component';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { SavePendingChangesComponent } from 'app/shared/components/save-pending-changes/save-pending-changes.component';
import { EMultipleAuthViewMode } from './security-authentication.enum';
import { SetMultipleViewMode, SetCurrentAuthenticator, UpdateMultipleAuthenticator, SaveAuthenticationData, UpdateAuthenticatorOption } from '../store/actions/authentication.actions';
import { SecurityAuthDetailComponent } from '../security-auth-detail/security-auth-detail.component';
import { IAppState } from 'app/IAppState';
import { MultipleAuthenticator } from './authentication-contracts';

@Injectable({
    providedIn: 'root'
})
export class PendingChangesMultiAuthService {
    private _store: Store<IAppState>;
    private _multipleAuthDetailComponent: MultipleAuthDetailComponent | SecurityAuthDetailComponent;
    private _modalRef: BzgModalRef;
    private _mode: EMultipleAuthViewMode;
    private _type: string;
    selectedAuthenticator: MultipleAuthenticator;
    nextAuthenticator: MultipleAuthenticator;
    toSaveAuthenticator: MultipleAuthenticator;

    constructor(private _modalService: BzgModalService) { }


    initialize(
        store: Store<IAppState>,
        multipleAuthDetailComponent: MultipleAuthDetailComponent | SecurityAuthDetailComponent
    ) {
        this._store = store;
        this._multipleAuthDetailComponent = multipleAuthDetailComponent;
    }


    public check(mode: EMultipleAuthViewMode, type: string = 'multiple') {
        this._type = type;
        this._mode = mode;
        if (this._type === 'security') {
            this._multipleAuthDetailComponent && this._multipleAuthDetailComponent.hasChanges
                ? this.dialogPendingChanges()
                : this.pendingChangesManagerSecurityDetail('continue');
        }
        else if (this._type === 'multiple') {
            this._multipleAuthDetailComponent && this._multipleAuthDetailComponent.hasChanges
                ? this.dialogPendingChanges()
                : this.pendingChangesManagerAuthenticator('continue');
        }
    }

    public checkOption(securityDetail: SecurityAuthDetailComponent, callback: Function) {
        if (securityDetail && securityDetail.hasChanges) {
            this._modalRef = this._modalService.open(SavePendingChangesComponent,
                { closeOnBackdropClick: false, closeOnRouterNavigation: true });
            this._modalRef.afterClosed().subscribe(result => {
                switch (result.action) {
                    case 'save':
                        this.updateSecurityDetail(false);
                        callback();
                        break;
                    case 'dontsave':
                    case 'continue':
                        callback();
                        break;
                    default:
                        break;
                }
            });
        }
    }

    dialogPendingChanges() {
        this._modalRef = this._modalService.open(SavePendingChangesComponent,
            { closeOnBackdropClick: false, closeOnRouterNavigation: true });
        this._modalRef.afterClosed().subscribe(result => {
            if (this._type === 'multiple') {
                this.pendingChangesManagerAuthenticator(result.action);
            } else if (this._type === 'security') {
                this.pendingChangesManagerSecurityDetail(result.action);
            }
        });
    }

    pendingChangesManagerAuthenticator(action: string) {
        if (!this._multipleAuthDetailComponent) {
            return;
        }
        this.toSaveAuthenticator = (this._multipleAuthDetailComponent as MultipleAuthDetailComponent).selectedAuthenticator;
        switch (action) {
            case 'save':
                this.updateAuthenticator();
                break;
            case 'dontsave':
            case 'continue':
                this.dispatchMode();
                break;
            default:
                break;
        }
    }

    pendingChangesManagerSecurityDetail(action: string) {
        if (!this._multipleAuthDetailComponent) {
            return;
        }
        switch (action) {
            case 'save':
                this.updateSecurityDetail();
                break;
            case 'dontsave':
            case 'continue':
                this.dispatchMode();
                break;
            default:
                break;
        }
    }

    updateAuthenticator() {
        (this._multipleAuthDetailComponent as MultipleAuthDetailComponent).updateAuthenticatorOptions();
        this._store.dispatch(new UpdateMultipleAuthenticator(this.toSaveAuthenticator));
        this._store.dispatch(new SaveAuthenticationData());
        this.dispatchMode();
    }

    async updateSecurityDetail(dispatch = true) {
        const securityAuthDetailComponent = (this._multipleAuthDetailComponent as SecurityAuthDetailComponent);
        const option = securityAuthDetailComponent.selectedOption;

        await securityAuthDetailComponent.checkForPasswordOptionAdEncrypt();

        if (securityAuthDetailComponent.fileNameProperty && securityAuthDetailComponent.currentFileName) {
        this._store.dispatch(new UpdateAuthenticatorOption({
            key: securityAuthDetailComponent.fileNameProperty,
            value: securityAuthDetailComponent.currentFileName }));
        }

        option.value = securityAuthDetailComponent.currentValue;
        securityAuthDetailComponent.selectedOption = option;
        this._store.dispatch(new UpdateAuthenticatorOption(option));
        this._store.dispatch(new SaveAuthenticationData());
        if (dispatch) {
            this.dispatchMode();
        }
    }

    dispatchMode() {
        switch (this._mode) {
            case EMultipleAuthViewMode.Add:
                this._store.dispatch(new SetMultipleViewMode(this._mode));
                const newAuthenticator: MultipleAuthenticator = {
                    type: '',
                    subtype: '',
                    displayName: '',
                    enabled: true,
                    domains: [],
                    options: {},
                    oauthOptions: {}
                };
                this._store.dispatch(new SetCurrentAuthenticator(newAuthenticator));
                break;
            case EMultipleAuthViewMode.Edit:
                this._store.dispatch(new SetMultipleViewMode(this._mode));
                this._store.dispatch(
                    new SetCurrentAuthenticator(this.selectedAuthenticator)
                );
                break;
            case EMultipleAuthViewMode.Unselect:
                this._store.dispatch(new SetMultipleViewMode(this._mode));
                this._store.dispatch(
                    new SetCurrentAuthenticator(null)
                );
                break;
        }
    }
}
